import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { useTenant } from "../../hooks/useTenant";
import { getRedirectForRole } from "../../lib/constants";
import { FullPageLoader } from "../ui/FullPageLoader";

export function PublicOnlyRoute({ children }: { children: ReactNode }) {
  const { user, loading: authLoading } = useAuth();
  const { currentRole, loading: tenantLoading } = useTenant();

  if (authLoading || (user && tenantLoading)) {
    return <FullPageLoader label="Opening CoachGrid" />;
  }

  if (user && currentRole) {
    return <Navigate to={getRedirectForRole(currentRole)} replace />;
  }

  return children;
}
